export enum PortalRoutesEmun {
  applications = 'applications',
  requestDocs = 'request-docs',
  hitl = 'hitl',
}
